import { useEffect, useState } from "react";
import { localUserProfileInteractor } from "di";
import { UserProfile } from "core";

import GenericCard from "components/UI/GenericCard/GenericCard";

type Props = {
  onClick?: () => void;
  className?: string;
};

export default function AboutHattrick({ onClick, className }: Props) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    (async () => {
      try {
        if (localUserProfileInteractor.existsUserProfile()) {
          const userProfile =
            localUserProfileInteractor.getUserProfile() as UserProfile;
          setProgress(userProfile.aboutHattrickPercentage);
        }
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  return (
    <div
      onClick={() => onClick}
      className={className}
      style={{ width: "100%", height: "100%" }}
    >
      <GenericCard
        title="About Hattrick"
        subtitle="Conocé nuestra historia y los valores que nos mueven.\n
        Te mostramos algunos proyectos en los que trabajamos y la dinámica de nuestro equipo."
        color="skyblue"
        progress={progress}
      />
    </div>
  );
}
